import api from '../utilBackoffice';

const controller = 'Remessa4111';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  GetAllPaged: dto => api.Axios.GetParams(url + '/grid-remessa', dto),
  Download: dto => api.Axios.DownloadJsonFile(url + '/Download', dto),
  Reprocessar: dto => api.Axios.Post(url + '/Reprocessar', dto)
});
